<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 md12>
        <v-card :v-if="invoiceDataAvailable">
          <v-card-title primary-title class="primary white--text headline">
            <!-- Invoice Payment 
            <v-spacer></v-spacer>   -->
            <h3 class="strong white--text font-weight-light headline">
              <b>{{ this.currentUser.name }}</b>
            </h3>
            <h5 class="subheading font-weight-light white--text">
              &nbsp; {{ this.currentUser.GST_number || "-" }}
            </h5>
            <!-- <v-spacer></v-spacer> -->
          </v-card-title>
          <v-card-text>
            <v-layout row>
              <!-- <v-flex xs4>
                <div>
                  Invoice Id:
                  <b class="title primary--text font-weight-bold">#{{selectedInvoiceId}}</b>
                </div>  
                <div>
                  Invoice Number:
                  <b class="title primary--text font-weight-bold">{{invoiceData['invoiceId']}}</b>
                </div>
                <div>
                  Billed on:
                  <b class="title primary--text font-weight-bold">{{ new Date(invoiceData['date']).toLocaleDateString('en-GB')}}</b>
                </div>
              </v-flex> -->
              <v-flex xs4>
                <div class="text-sm-left subheading font-weight-light">
                  Invoice Id:
                  <b class="font-weight-bold">#{{ selectedInvoiceId }}</b>
                </div>
                <div class="text-sm-left subheading font-weight-light">
                  Invoice No:
                  <b class="font-weight-bold">{{ invoiceData["invoiceId"] }}</b>
                </div>
                <div class="text-sm-left subheading font-weight-light">
                  Billed on:
                  <b class="font-weight-bold">
                    {{
                      new Date(invoiceData["date"]).toLocaleDateString("en-GB")
                    }}
                  </b>
                </div>
              </v-flex>
              <v-flex xs4>
                <div class="text-sm-left subheading font-weight-light">
                  Total Amount:
                  <b class="success--text font-weight-bold">
                    {{
                      Number.parseFloat(invoiceData["totalAmount"]) ||
                      0 | amount
                    }}</b
                  >
                </div>
                <div class="text-sm-left subheading font-weight-light">
                  Paid Amount:
                  <b class="warning--text font-weight-bold">
                    {{ invoiceData["paidAmount"] || 0 | amount }}</b
                  >
                </div>
                <div class="text-sm-left subheading font-weight-light">
                  Due Amount:
                  <b class="error--text font-weight-bold">
                    {{ invoiceData["remainingAmount"] || 0 | amount }}
                  </b>
                </div>
              </v-flex>
              <!-- <v-flex xs4>
                <div class="text-sm-left title font-weight-headline">
                  Total Amount:
                  <b>₹. {{invoiceData['totalAmount']}}</b>
                </div>
                <br />
                <div class="text-sm-left title font-weight-headline">
                  Paid Amount:
                  <b>₹. {{invoiceData['paidAmount']}}</b>
                </div>
                <br />
                <div class="text-sm-left title font-weight-headline">
                  Due Amount:
                  <b>₹. {{invoiceData['remainingAmount']}}</b>
                </div>
              </v-flex> -->
              <v-flex xs4>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepicker"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="closedDate"
                    label="Closing Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="closedDate"
                    @input="datepicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-data-table
            :headers="headers"
            :items="invoiceData.items"
            hide-actions
            class="elevation-1"
            item-key="index"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.productName }}</td>
              <!-- <td class="text-xs-left">{{ props.item.HSN_code }}</td> -->
              <!-- <td>{{ props.item.taxableGST_rate }}</td> -->
              <td>{{ props.item.unit }}</td>
              <td>{{ props.item.rate }}</td>
              <td>{{ props.item.quantity }}</td>
              <td>{{ props.item.basicPrice }}</td>
              <td>{{ props.item.GSTValue }}</td>
              <td>{{ props.item.totlePrice }}</td>
              <td>{{ props.item.CGST_val }} ({{ props.item.CGST }} %)</td>
              <td>{{ props.item.SGST_val }} ({{ props.item.SGST }} %)</td>
              <td>{{ props.item.IGST_val }} ({{ props.item.IGST }} %)</td>
            </template>
          </v-data-table>
          <v-spacer></v-spacer>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs3>
                <v-select
                  dense
                  :items="firmsByBrand"
                  label="Select Firm"
                  readonly
                  v-model="invoiceData.firm"
                ></v-select>

                <v-btn
                  v-if="invoiceData.transactionType"
                  color="blue darken-1"
                  flat
                  @click.native="transactionDialog = true"
                  >Transaction Details</v-btn
                >
              </v-flex>
              <v-flex xs3>
                <v-select
                  dense
                  :items="[
                    {
                      text: 'Partial Paid',
                      value: 'Partial Paid',
                    },
                    {
                      text: 'Full Paid',
                      value: 'Credit',
                    },
                  ]"
                  label="Select Transaction type"
                  @input="transactionDialog = true"
                  v-model="invoiceData.transactionType"
                ></v-select>
              </v-flex>

              <v-flex xs3>
                <div class="">
                  Amount Deposited:
                  <br />
                  <b v-if="nowDepositedIsDirty">{{
                    (
                      Number.parseFloat(invoiceData["amountFromBank"]) +
                      Number.parseFloat(invoiceData["amountFromCash"])
                    ).toFixed(roundOff)
                  }}</b>
                  <b v-if="!nowDepositedIsDirty">0</b>
                </div>
              </v-flex>
              <v-flex xs3>
                <div class="">
                  Amount Remaining:
                  <br />
                  <b v-if="nowDepositedIsDirty">{{
                    Number.parseFloat(invoiceData["amountToBePaid"])
                  }}</b>
                  <b v-if="!nowDepositedIsDirty">{{
                    invoiceData["remainingAmount"]
                  }}</b>
                </div>

                <v-btn
                  v-if="invoiceData.transactionType"
                  class="primary white--text"
                  large
                  flat
                  @click.native="updateInvoice"
                  >Update Payment
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-divider></v-divider>
          <v-dialog v-model="transactionDialog" persistent max-width="1000px">
            <v-card>
              <v-card-title class="primary white--text">
                <span class="headline"
                  >Payment Details
                  <!-- :- {{invoiceData.transactionType}} -->
                </span>
                <v-spacer />
                <v-btn icon dark @click="transactionDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs3>
                      <v-text-field
                        type="number"
                        label="Total Amount"
                        readonly
                        :value="invoiceData.totalAmount"
                        prefix
                      ></v-text-field>
                      <v-text-field
                        readonly
                        :value="invoiceData['remainingAmount']"
                        type="number"
                        label="Due Amount"
                      ></v-text-field>

                      <v-text-field
                        readonly
                        :value="invoiceData['paidAmount']"
                        type="number"
                        label="Previously Paid Amount"
                      ></v-text-field>

                      <v-text-field
                        type="number"
                        label="Discount "
                        v-model="invoiceData.discountAmount"
                      ></v-text-field>

                      <v-text-field
                        type="number"
                        label="Additional Discount "
                        v-model="additionalDiscount"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs1> </v-flex>

                    <v-flex xs3>
                      <!-- <v-text-field
                        readonly
                        :value="(Number.parseFloat(invoiceData.totalAmount) - (Number.parseFloat(GST_Val_total.SGST_val) + Number.parseFloat(GST_Val_total.CGST_val) + Number.parseFloat(GST_Val_total.IGST_val)))"
                        type="number"
                        label="Basic Amount"
                      ></v-text-field>
           
                      <v-text-field type="number" label="Round Off" v-model="roundOff"></v-text-field> -->

                      <v-select
                        dense
                        :items="[
                          {
                            text: 'Cash',
                            value: 'Cash',
                          },
                          {
                            text: 'Bank Account',
                            value: 'Bank Account',
                          },
                          {
                            text: 'Cash & Bank Account',
                            value: 'CashAndBank Account',
                          },
                        ]"
                        label="Select Payment Type"
                        @change="resetAmounts()"
                        v-model="invoiceData.paymentType"
                      ></v-select>

                      <!-- <v-select
                        dense
                        :items="banksByFirms"
                        label="Select Bank"
                        v-model="invoiceData.bank"
                      ></v-select> -->

                      <v-select
                        dense
                        :items="banksByFirms"
                        v-if="
                          invoiceData.paymentType != 'Cash' &&
                          invoiceData.paymentType != ''
                        "
                        label="Select Bank"
                        v-model="invoiceData.bank"
                        required
                      >
                        <template slot="selection" slot-scope="data">
                          {{ data.item.account.accountnumber }}
                          {{
                            data.item.account.bankName
                              ? " | " + data.item.account.bankName
                              : ""
                          }}
                        </template>
                        <template slot="item" slot-scope="data">
                          <v-list-tile-content>
                            <v-list-tile-title
                              v-html="
                                `${data.item.account.accountnumber}
                                      ${
                                        data.item.account.bankName
                                          ? ' | ' + data.item.account.bankName
                                          : ''
                                      }
                                      ${
                                        data.item.account.accountType
                                          ? ' | ' +
                                            data.item.account.accountType
                                          : ''
                                      }
                                      | ₹: ${(
                                        data.item.account.amount || 0
                                      ).toLocaleString()}`
                              "
                            />
                          </v-list-tile-content>
                        </template>
                      </v-select>

                      <v-select
                        dense
                        v-if="
                          invoiceData.paymentType != 'Cash' &&
                          invoiceData.paymentType != ''
                        "
                        :items="[
                          {
                            text: 'Cheque',
                            value: 'Cheque',
                          },
                          {
                            text: 'NEFT',
                            value: 'NEFT',
                          },
                          {
                            text: 'RTGS',
                            value: 'RTGS',
                          },
                          {
                            text: 'IMPS',
                            value: 'IMPS',
                          },
                        ]"
                        label="Select Transfer type"
                        v-model="invoiceData.transferType"
                        @input="transferTypeDialog = true"
                      ></v-select>

                      <!-- <v-text-field
                        type="number"
                        label="Available Balance "
                        readonly
                        :value="availableBalance"
                      ></v-text-field> -->

                      <v-text-field
                        type="number"
                        label="Remaining Amount "
                        readonly
                        :value="invoiceData.amountToBePaid"
                        prefix
                      ></v-text-field>
                    </v-flex>

                    <v-flex x1> </v-flex>

                    <v-flex xs3>
                      <v-text-field
                        v-model="invoiceData.amountFromCash"
                        type="number"
                        :disabled="amountFromCashDisabled"
                        :hint="hintText"
                        label="Amount from Cash"
                      ></v-text-field>

                      <v-text-field
                        v-model="invoiceData.amountFromBank"
                        type="number"
                        :hint="hintText"
                        :disabled="amountFromBankDisabled"
                        label="Amount from Bank"
                      ></v-text-field>
                      <b
                        class="red--text font-weight-bold"
                        v-if="
                          invoiceData.status == 'paid'
                            ? Number.parseFloat(invoiceData.amountToBePaid) != 0
                            : false
                        "
                        >In Full payment, Paid Amount should be equal to
                        Remaining Amount</b
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="blue darken-1" flat @click.native="transactionDialog = false">Confirm</v-btn> -->
                <!-- <v-btn color="blue darken-1" :disabled="!invoiceData.paymentType" flat @click.native="transactionDialog = false">Confirm</v-btn> -->
                <v-btn
                  color="blue darken-1"
                  :disabled="
                    !invoiceData.paymentType ||
                    (invoiceData.status == 'paid'
                      ? Number.parseFloat(invoiceData.amountToBePaid) != 0
                      : false)
                  "
                  flat
                  @click.native="transactionDialog = false"
                  >Confirm</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="transferTypeDialog" persistent max-width="500px">
            <v-card>
              <v-card-title class="primary white--text">
                <span class="headline">
                  Transfer Information
                  <b>{{ transferTypeDialog.transferType }}</b>
                </span>
                <v-spacer />
                <v-btn icon dark @click="transferTypeDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                        v-model="transferDetails.accountNumber"
                        label="A/C Number"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="text"
                        v-model="transferDetails.accountHolderName"
                        label="A/C Holder Name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="text"
                        v-model="transferDetails.bankName"
                        label="Bank Name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="text"
                        v-model="transferDetails.IFSCcode"
                        label="IFSC Code"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="text"
                        v-model="transferDetails.remark"
                        label="Remark"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="transferTypeDialog = false"
                  >Ok</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import { digitsToWords } from "../../../utils/digitsToWords.js";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];

export default {
  props: {
    selectedInvoiceId: {
      required: true,
    },
    isBuyer: {
      required: true,
    },
    firms: {
      type: Array,
    },
    banks: {
      type: Array,
    },
    buyers: {
      type: Array,
    },
    sellers: {
      type: Array,
    },
  },
  data() {
    return {
      invoiceData: null,
      invoiceDataAvailable: false,
      headers: [
        {
          text: "Name",
          sortable: false,
          value: "productName",
          class: "primary--text font-weight-bold",
        },
        // { text: "HSN code", sortable: false, value: "HSN_code", class: "primary--text font-weight-bold" },
        // { text: "GST", sortable: false, value: "taxableGST_rate", class: "primary--text font-weight-bold" },
        {
          text: "Unit",
          sortable: false,
          value: "unit",
          class: "primary--text font-weight-bold",
        },
        {
          text: "Rate",
          sortable: false,
          value: "rate",
          class: "primary--text font-weight-bold",
        },
        {
          text: "Quantity",
          sortable: false,
          value: "quantity",
          class: "primary--text font-weight-bold",
        },
        {
          text: "Basic Price",
          sortable: false,
          value: "basicPrice",
          class: "primary--text font-weight-bold",
        },
        {
          text: "GST value",
          sortable: false,
          value: "GSTValue",
          class: "primary--text font-weight-bold",
        },
        {
          text: "Total Price",
          sortable: false,
          value: "totlePrice",
          class: "primary--text font-weight-bold",
        },
        {
          text: "CGST value ( %)",
          sortable: false,
          value: "CGST",
          class: "primary--text font-weight-bold",
        },
        {
          text: "SGST value ( %)",
          sortable: false,
          value: "SGST",
          class: "primary--text font-weight-bold",
        },
        {
          text: "IGST value ( %)",
          sortable: false,
          value: "IGST",
          class: "primary--text font-weight-bold",
        },
      ],
      datepicker: null,
      closedDate: new Date().toISOString().substr(0, 10),
      additionalDiscount: 0,
      transferTypeDialog: false,
      transactionDialog: false,
      GST_Val_total: {
        CGST_val: 0,
        SGST_val: 0,
        IGST_val: 0,
      },
      transferDetails: {
        accountNumber: "",
        accountHolderName: "",
        bankName: "",
        IFSCcode: "",
        remark: "",
      },
      roundOff: 2,
      amountFromCashDisabled: true,
      amountFromBankDisabled: true,
      currentUser: {},
      availableBalance: 0,
      nowDepositedIsDirty: false,
      // currentUser: {},
      hintText: null,
    };
  },
  mounted() {
    this.getCurrentUser();
  },
  created() {
    this.$bindAsArray(
      "invoices",
      this.$root.$firebaseRefs.invoice
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapBuyerGetters(["selectedBuyer"]),
    ...mapGlobalGetters(["selectedBrand"]),
    firmsByBrand() {
      return this.firms
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    banksByFirms() {
      return this.banks
        .filter((item) => {
          return (
            item["brand"] === this.selectedBrand &&
            item["firm"] === this.invoiceData.firm
          );
        })
        .map((item) => {
          return {
            account: item,
            text: item["bankName"],
            value: item[".key"],
          };
        });
    },
  },
  watch: {
    selectedInvoiceId(oldVal, newVal) {
      this.invoiceData = null;
      this.invoiceData = JSON.parse(
        JSON.stringify(
          this.invoices.filter(
            (item) => item[".key"] == this.selectedInvoiceId
          )[0]
        )
      );
      this.invoiceDataAvailable = true;
      this.invoiceData.status = "paid";
      this.invoiceData.transactionType = "";
      this.invoiceData.amountFromCash = this.invoiceData.remainingAmount;
      this.invoiceData.amountFromBank = 0;
      this.calculateTotal();
    },
    transactionDialog(oldVal, newVal) {
      this.nowDepositedIsDirty = true;
    },
    "invoiceData.firm": {
      handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          this.getFirmAndBankBalance();
          this.calculateGSTType();
        }
      },
      deep: true,
    },
    "invoiceData.paymentType": {
      handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          if (this.firm != "") this.getFirmAndBankBalance();
          this.calculateTotal();
        }
      },
      deep: true,
    },
    additionalDiscount: {
      handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          this.calculateTotal();
        }
      },
      deep: true,
    },
    "invoiceData.bank": {
      handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          this.getFirmAndBankBalance();
        }
      },
      deep: true,
    },
    "invoiceData.amountFromCash": {
      handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          this.calculateTotal();
        }
        this.hintText = this.invoiceData.amountFromCash
          ? _.startCase(
              digitsToWords(Number.parseFloat(this.invoiceData.amountFromCash))
            )
          : null;
      },
      deep: true,
    },
    "invoiceData.amountFromBank": {
      handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          this.calculateTotal();
        }
        this.hintText = this.invoiceData.amountFromBank
          ? _.startCase(
              digitsToWords(Number.parseFloat(this.invoiceData.amountFromBank))
            )
          : null;
      },
      deep: true,
    },
    "invoiceData.discountAmount": {
      handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          this.invoiceData.amountFromCash = 0;
          this.invoiceData.amountFromBank = 0;
          this.calculateTotal();
        }
      },
      deep: true,
    },
    "invoiceData.transactionType": {
      handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          switch (newVal) {
            case "Partial Paid": {
              this.invoiceData.status = "partial";
              this.invoiceData.transactionType = "Partial Paid";
              break;
            }
            case "Credit": {
              this.invoiceData.status = "paid";
              this.invoiceData.transactionType = "Credit";
              break;
            }
          }
          this.calculateTotal();
        }
      },
      deep: true,
    },
    roundOff(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal();
      }
    },
  },
  methods: {
    calculateTotal() {
      let discountAmount = Number.parseFloat(this.additionalDiscount);
      let amountFromBank = Number.parseFloat(this.invoiceData.amountFromBank);
      let amountFromCash = Number.parseFloat(this.invoiceData.amountFromCash);
      let totalAmount = Number.parseFloat(this.invoiceData.totalAmount);
      let paidAmount = Number.parseFloat(this.invoiceData.paidAmount);
      switch (this.invoiceData.paymentType) {
        case "Cash": {
          this.invoiceData.amountFromBank = 0;
          this.amountFromBankDisabled = true;
          this.amountFromCashDisabled = false;
          this.invoiceData.amountToBePaid =
            totalAmount - (discountAmount + amountFromCash + paidAmount);
          // this.invoiceData.paidAmount = 0;
          break;
        }

        case "Bank Account": {
          this.amountFromCashDisabled = true;
          this.amountFromBankDisabled = false;
          this.invoiceData.amountFromCash = 0;
          this.invoiceData.amountToBePaid =
            totalAmount - (discountAmount + amountFromBank + paidAmount);
          //this.invoiceData.paidAmount = 0;
          break;
        }
        case "CashAndBank Account": {
          this.amountFromCashDisabled = false;
          this.amountFromBankDisabled = false;
          let totalBankAndCash = amountFromCash + amountFromBank;
          this.invoiceData.amountToBePaid =
            totalAmount - (discountAmount + totalBankAndCash + paidAmount);
          //this.paidAmount = 0;
          break;
        }
      }
      this.invoiceData.amountToBePaid = Number.parseFloat(
        this.invoiceData.amountToBePaid
      ).toFixed(this.roundOff);
      this.invoiceData.totalAmount = Number.parseFloat(
        this.invoiceData.totalAmount
      ).toFixed(this.roundOff);
    },
    getFirmAndBankBalance() {
      switch (this.invoiceData.paymentType) {
        case "Cash": {
          if (this.invoiceData.firm) {
            let firm = this.firms.filter(
              (item) =>
                item["brand"] === this.selectedBrand &&
                item[".key"] == this.invoiceData.firm
            );
            this.availableBalance =
              firm.length && (firm[0]["amount"] ? firm[0]["amount"] : 0);
          } else {
            this.availableBalance = 0;
          }
          break;
        }
        case "Bank Account": {
          if (this.invoiceData.bank) {
            let bank = this.banks.filter(
              (item) =>
                item["brand"] === this.selectedBrand &&
                item[".key"] == this.invoiceData.bank
            );
            this.availableBalance =
              bank.length && (bank[0]["amount"] ? bank[0]["amount"] : 0);
          } else {
            this.availableBalance = 0;
          }
          break;
        }
        case "CashAndBank Account": {
          if (this.invoiceData.firm && this.invoiceData.bank) {
            let firm = this.firms.filter(
              (item) =>
                item["brand"] === this.selectedBrand &&
                item[".key"] == this.invoiceData.firm
            );
            let bank = this.banks.filter(
              (item) =>
                item["brand"] === this.selectedBrand &&
                item[".key"] == this.invoiceData.bank
            );
            this.availableBalance =
              firm.length &&
              bank.length &&
              (bank[0]["amount"] ? bank[0]["amount"] : 0) +
                (firm[0]["amount"] ? firm[0]["amount"] : 0);
          } else {
            this.availableBalance = 0;
          }
          break;
        }
      }
    },
    resetAmounts() {
      this.amountFromCash = 0;
      this.amountFromBank = 0;
      this.discountAmount = 0;
    },
    calculateGSTType() {
      if (Object.keys(this.currentUser).length === 0) {
        this.getCurrentUser();
      }
      this.GST_Val_total.SGST_val = 0;
      this.GST_Val_total.CGST_val = 0;
      this.GST_Val_total.IGST_val = 0;
      this.invoiceData.items.map((item, index) => {
        let GST = item["taxableGST_rate"];
        let firm = this.firms.filter(
          (item) => item[".key"] == this.invoiceData.firm
        )[0];
        if (
          this.invoiceData.firm &&
          this.currentUser &&
          this.currentUser.state &&
          Number.parseFloat(GST) &&
          firm.state === this.currentUser.state
        ) {
          item["CGST_val"] = item["GSTValue"] / 2;
          item["CGST"] = GST / 2;
          item["SGST_val"] = item["GSTValue"] / 2;
          item["SGST"] = GST / 2;
          item["IGST"] = 0;
          item["IGST_val"] = 0;
          this.GST_Val_total.SGST_val += Number.parseFloat(item["SGST_val"]);
          this.GST_Val_total.CGST_val += Number.parseFloat(item["CGST_val"]);
          this.GST_Val_total.IGST_val += Number.parseFloat(item["IGST_val"]);
          this.invoiceData.gstType = "SGST|CGST";
        } else {
          item["IGST"] = GST;
          item["CGST"] = 0;
          item["SGST"] = 0;
          item["IGST_val"] = item["GSTValue"];
          item["CGST_val"] = 0;
          item["SGST_val"] = 0;
          this.GST_Val_total.SGST_val += Number.parseFloat(item["SGST_val"]);
          this.GST_Val_total.CGST_val += Number.parseFloat(item["CGST_val"]);
          this.GST_Val_total.IGST_val += Number.parseFloat(item["IGST_val"]);
          this.invoiceData.gstType = "IGST";
        }
        this.invoiceData.items[index] = item;
      });
    },
    getCurrentUser() {
      let buyer = this.buyers.filter(
        (item) => item[".key"] === this.invoiceData.buyerId
      )[0];
      let seller = this.sellers.filter(
        (item) => item[".key"] === this.invoiceData.buyerId
      )[0];
      this.currentUser =
        buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
    },
    // getCurrentUserOne() {
    //   let buyer = this.buyerById[this.selectedBuyer];
    //   let seller = this.sellerById[this.selectedBuyer];
    //   this.isUserBuyer = buyer ? true : false;
    //   this.currentUser =
    //     buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
    // },
    createReceipt(invoiceData) {
      let firm = this.firms.find((item) => item[".key"] == invoiceData.firm);
      let firmReceiptCount = invoiceData.isBuyer ? (firm.lastReceiptCount ? (Number.parseInt(firm.lastReceiptCount) +1) : 1) : (firm.lastReceiptCountSeller ? (Number.parseInt(firm.lastReceiptCountSeller) +1) : 1);
      let amountToBePaid =
        Number.parseFloat(invoiceData.amountFromCash) +
        Number.parseFloat(invoiceData.amountFromBank);
      let receipt = {
        date: invoiceData.closedDate,
        firm: invoiceData.firm,
        isBuyer: invoiceData.isBuyer,
        buyerId: invoiceData.buyerId,
        brand: invoiceData.brand,
        amount: amountToBePaid,
        remainingAmount: 0,
        receiptNumber: firmReceiptCount,
        paymentType : invoiceData.paymentType,
        settledInvoiceDetails: [
          {
            invoiceId: invoiceData[".key"],
            settledAmount: amountToBePaid,
            status: invoiceData.status,
          },
        ],
      };

      if (invoiceData.paymentType == "Bank") {
        receipt["transferType"] = invoiceData.transferType;
        receipt["transferDetails"] = invoiceData.transferDetails;
      }
      console.log(receipt)
      this.$root.$firebaseRefs.customerPayments.push(receipt);
       if(invoiceData.isBuyer) {
        this.$root.$firebaseRefs.firm.child(receipt.firm).update(
        {
          lastReceiptCount: Number.parseInt(receipt.receiptNumber),
        },
        () => {
          //console.info("last receiptNumber updated...");
        }
      );
      } else {
        this.$root.$firebaseRefs.firm.child(receipt.firm).update(
        {
          lastReceiptCountSeller: Number.parseInt(receipt.receiptNumber),
        },
        () => {
          //console.info("last receiptNumber updated...");
        }
      );
      }
    },
    updateInvoice() {
      let closedDate = new Date(this.closedDate);
      let todayDate = new Date();
      let selectedDate = new Date(
        closedDate.getFullYear(),
        closedDate.getMonth(),
        closedDate.getDate(),
        todayDate.getHours(),
        todayDate.getMinutes(),
        todayDate.getSeconds()
      );
      this.invoiceData.closedDate = new Date(selectedDate).getTime();
      // this.invoiceData.date = this.invoiceData.closedDate;
      if (this.additionalDiscount) {
        this.invoiceData.totalAmount =
          Number.parseFloat(this.invoiceData.totalAmount) -
          Number.parseFloat(this.additionalDiscount);
        this.invoiceData.discountAmount =
          (this.invoiceData.discountAmount
            ? Number.parseFloat(this.invoiceData.discountAmount)
            : 0) + Number.parseFloat(this.additionalDiscount);
      }
      this.invoiceData[".key"] = this.selectedInvoiceId;
      let amountFromBank = Number.parseFloat(this.invoiceData.amountFromBank);
      let amountFromCash = Number.parseFloat(this.invoiceData.amountFromCash);
      let totalAmount = Number.parseFloat(this.invoiceData.totalAmount);

      let paidAmount = Number.parseFloat(this.invoiceData.paidAmount);

      switch (this.invoiceData.paymentType) {
        case "Cash": {
          switch (this.invoiceData.transactionType) {
            case "Partial Paid": {
              this.invoiceData.remainingAmount =
                totalAmount - (amountFromCash + paidAmount);
              this.invoiceData.paidAmount = paidAmount + amountFromCash;
              break;
            }
            case "Credit": {
              this.invoiceData.remainingAmount = 0;
              this.invoiceData.paidAmount = totalAmount;
              break;
            }
          }
          break;
        }

        case "Bank Account": {
          switch (this.invoiceData.transactionType) {
            case "Partial Paid": {
              this.invoiceData.remainingAmount =
                totalAmount - (amountFromBank + paidAmount);
              this.invoiceData.paidAmount = paidAmount + amountFromBank;
              break;
            }
            case "Credit": {
              this.invoiceData.remainingAmount = 0;
              this.invoiceData.paidAmount = totalAmount;
              break;
            }
          }
          break;
        }
        case "CashAndBank Account": {
          switch (this.invoiceData.transactionType) {
            case "Partial Paid": {
              this.invoiceData.remainingAmount =
                totalAmount - (amountFromCash + amountFromBank + paidAmount);
              this.invoiceData.paidAmount =
                paidAmount + amountFromCash + amountFromBank;
              break;
            }
            case "Credit": {
              this.invoiceData.remainingAmount = 0;
              this.invoiceData.paidAmount = totalAmount;
              break;
            }
          }
          break;
        }
      }
      this.invoiceData.paidAmount = Number.parseFloat(
        this.invoiceData.paidAmount
      ).toFixed(this.roundOff);
      this.invoiceData.remainingAmount = Number.parseFloat(
        this.invoiceData.remainingAmount
      ).toFixed(this.roundOff);
      this.invoiceData["isPayment"] = true;
      this.createReceipt(this.invoiceData);
      this.$emit("updateInvoice", this.invoiceData);
    },
  },
};
</script>


<style>
.customTab th.column.text-xs-left {
  text-align: center !important;
}

.theme--light.v-stepper .v-stepper__label {
  color: rgb(1, 87, 155);
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/Buyers/InvoicePayment/index.vue